import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { ExtranetUserOutput, MembersListInput } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { unwrapItems, type ListPayload } from '../listShape';
import { extranetQueryKeys } from '../queryKeys';

/**
 * `GET /v1/users` — les membres extranet du compte, déduit de la session.
 * Pas de total renvoyé : la pagination se fait à l'aveugle (« suivant » actif
 * tant que la page est pleine).
 */
export const useMembers = (input: MembersListInput) =>
  useQuery({
    queryKey: extranetQueryKeys.members.list(input),
    queryFn: async () => {
      const payload = await getExtranetApi().get<MembersListInput, ListPayload<ExtranetUserOutput>>('/v1/users', input);
      return unwrapItems(payload);
    },
    placeholderData: keepPreviousData,
  });
